import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import seoConfig, { defaultSEO, BASE_URL } from './seoConfig';

export default function SEO({ overrides = {} }) {
  const { pathname } = useLocation();

  const baseRoute = '/' + pathname.split('/')[1];
  const pageSEO = seoConfig[pathname] || seoConfig[baseRoute] || defaultSEO;
  const meta = { ...pageSEO, ...overrides };

  const imageUrl = meta.image?.startsWith('http')
    ? meta.image
    : `${BASE_URL}${meta.image}`;

  const pageUrl = `${BASE_URL}${pathname}`;

  useEffect(() => {
    document.title = meta.title;
    setMeta('name', 'description',  meta.description);
    setMeta('name', 'keywords',     meta.keywords);
    setMeta('name', 'robots',       'index, follow');
    setMeta('name', 'author',       'Nutralike');
    setLink('canonical', pageUrl);
    setMeta('property', 'og:title',       meta.title);
    setMeta('property', 'og:description', meta.description);
    setMeta('property', 'og:image',       imageUrl);
    setMeta('property', 'og:url',         pageUrl);
    setMeta('property', 'og:type',        meta.type || 'website');
    setMeta('property', 'og:site_name',   'Nutralike');
    setMeta('property', 'og:locale',      'en_US');
    setMeta('name', 'twitter:card',        'summary_large_image');
    setMeta('name', 'twitter:title',       meta.title);
    setMeta('name', 'twitter:description', meta.description);
    setMeta('name', 'twitter:image',       imageUrl);
    setMeta('name', 'twitter:site',        '@nutralike');
  }, [pathname]);

  return null;
}

function setMeta(attrKey, attrValue, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attrKey}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrKey, attrValue);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}